//libs
import isEmpty from 'lodash/isEmpty';

//helpers
import { getRedirectionURLWithCurrentPage } from 'shared/components/OTPVerification/helpers';
import { generateTrackingUrlForMegaMenu } from 'shared/components/Header/helpers';
import NFA from 'shared/helpers/analytics/NFAnalytics';

//constants
import { ADDRESS_BOOK, AUTH_URI } from 'shared/constants/uri';
import { IMapOfString } from 'global';
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { LOGIN_PAGE } from 'shared/helpers/analytics/constants/loginEvents';

const MY_ACCOUNT = 'myAccount';
const ADDRESSBOOK = 'addressBook';

interface NavigationInterface {
  identifier: string;
  url: string;
  isLoggedIn: boolean;
  otherData: any;
  isBottomSheetVisible: boolean;
  showBottomSheetAuth: (url: string, disableTruecaller?: boolean) => void;
  showConfirm: (onConfirm: VoidFunction, onCancel?: VoidFunction) => void;
  push: (path: string) => void;
}

const goToUrl = (data: IMapOfString | string) => {
  if (isEmpty(data)) return;

  window.location.href = typeof data === 'string' ? data : generateTrackingUrlForMegaMenu(data);
};

const ifNotLoggedIn = (id: string | number) => {
  return getRedirectionURLWithCurrentPage({
    url: AUTH_URI.LOGIN_VIA_MOBILE_TO_MY_ORDER,
    pathname: `${window.location.protocol}//${window.location.host}${id}`,
    search: '',
  });
};

export const NavigationHandler = (params: NavigationInterface) => {
  const {
    identifier,
    url,
    isLoggedIn,
    otherData,
    isBottomSheetVisible,
    showBottomSheetAuth,
    showConfirm,
    push,
  } = params;

  const loginLocation = `${MY_ACCOUNT}:${identifier.toLowerCase()}`;

  switch (identifier) {
    case 'ORDERS':
      if (!isLoggedIn && isBottomSheetVisible) {
        NFA.updateDataLayer({
          loginPage: LOGIN_PAGE.MY_ACCOUNT_PAGE,
          loginLocation,
        });

        showBottomSheetAuth(url, false);

        break;
      }
      goToUrl(url);
      break;
    case 'WISHLIST':
      NFA.updateDatalayerBeforeNext(
        {
          pageviewLoacation: `${NFA.pageProperties.pagename}:${identifier.toLowerCase()}`,
        },
        TRACK_TYPE.PAGELOAD
      );

      if (!isLoggedIn && isBottomSheetVisible) {
        NFA.updateDataLayer({ loginPage: '', loginLocation });

        showBottomSheetAuth(url, false);

        break;
      }
      goToUrl(url);
      break;
    case 'ONR':
      if (!isLoggedIn && isBottomSheetVisible) {
        showBottomSheetAuth(url, false);

        break;
      }
      window.location.href = url;
      break;
    case 'COUPON':
      goToUrl(url);
      break;
    case 'REWARDS':
      {
        if (!isLoggedIn && isBottomSheetVisible) {
          NFA.updateDataLayer({
            loginPage: LOGIN_PAGE.MY_ACCOUNT_PAGE,
            loginLocation,
          });

          showBottomSheetAuth(url, false);

          break;
        }
        window.location.href = url;
      }
      break;

    case 'MY_GIFT_CARDS':
      {
        if (otherData.showRedirectionPopup === false) {
          window.location.href = url;
          break;
        }

        showConfirm(() => {
          window.location.href = url;
        });
      }
      break;

    case 'PROFILE':
      {
        let path: string;
        if (!isLoggedIn) {
          if (isBottomSheetVisible) {
            NFA.updateDataLayer({
              loginLocation,
            });

            showBottomSheetAuth(url, false);

            break;
          }
          path = ifNotLoggedIn(url);
        } else path = url;
        window.scrollTo(0, 0);
        push(path);
      }
      break;

    case 'HELP_CENTER':
      goToUrl(url);
      break;
    case 'CHAT_WITH_US':
      goToUrl(url);
      break;
    case 'ADDRESS_BOOK':
      if (isLoggedIn) {
        return goToUrl(url);
      } else if (isBottomSheetVisible) {
        NFA.updateDataLayer({
          loginPage: LOGIN_PAGE.MY_ACCOUNT_PAGE,
          loginLocation: `${MY_ACCOUNT}:${ADDRESSBOOK}`,
        });

        return showBottomSheetAuth(ADDRESS_BOOK);
      } else {
        const path = ifNotLoggedIn(ADDRESS_BOOK);
        return push(path);
      }
    default:
      goToUrl(url);
      break;
  }
};
